import { FieldValues, useController } from 'react-hook-form';
import { Field, FieldProps as SWFieldProps } from '@spark-web/field';
import { Select, SelectProps } from '@spark-web/select';
import type { FormFieldProps } from '../Form';

export type SelectFieldProps<TFieldValues extends FieldValues = FieldValues> = FormFieldProps<TFieldValues> &
  SelectProps & { fieldProps?: Omit<SWFieldProps, 'label' | 'children'> };

function SelectField<TFieldValues extends FieldValues = FieldValues>({
  name,
  label,
  control,
  shouldUnregister,
  fieldProps,
  ...selectProps
}: SelectFieldProps<TFieldValues>) {
  const {
    field,
    fieldState: { error },
  } = useController<TFieldValues>({
    name,
    control,
    rules: {
      onBlur: selectProps?.onBlur,
      onChange: selectProps?.onChange,
    },
    shouldUnregister,
  });

  return (
    <Field
      label={label}
      {...fieldProps}
      tone={error ? 'critical' : fieldProps?.tone}
      message={error?.message ?? fieldProps?.message}
    >
      <Select {...selectProps} {...field} />
    </Field>
  );
}

export default SelectField;
